/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApprovalWorkCenter } from '../../models/approval-work-center';

export interface GetApprovalWorkCenters$Params {
  workCenterGroupId: number;
  approvalReportDate: string;
}

export function getApprovalWorkCenters(http: HttpClient, rootUrl: string, params: GetApprovalWorkCenters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApprovalWorkCenter>>> {
  const rb = new RequestBuilder(rootUrl, getApprovalWorkCenters.PATH, 'get');
  if (params) {
    rb.path('workCenterGroupId', params.workCenterGroupId, {});
    rb.path('approvalReportDate', params.approvalReportDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApprovalWorkCenter>>;
    })
  );
}

getApprovalWorkCenters.PATH = '/api/v1/workCenterGroups/{workCenterGroupId}/approvals/{approvalReportDate}/workCenters';
